import { render, staticRenderFns } from "./AccountPasswordReset.vue?vue&type=template&id=010ef076"
import script from "./AccountPasswordReset?vue&type=script&lang=ts&external"
export * from "./AccountPasswordReset?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports